import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {DeviceAddResponse} from "../../types/Device"
import {StoreState} from "../../store"
import {useSelector} from "react-redux"

export interface StateProps {
  loading: boolean
  total: number
  requests: DeviceAddResponse["data"]
}

const initialState: StateProps = {
  loading: false,
  total: 0,
  requests: []
}

const deviceAddRequestSlice = createSlice({
  name: "deviceAdd",
  initialState,
  reducers: {
    addNewRequest: (
      state,
      action: PayloadAction<DeviceAddResponse["data"][0]>
    ) => {
      if (
        state.requests.findIndex((data) => data.id === action.payload.id) < 0
      ) {
        state.requests = [...state.requests, action.payload]
        state.total = ++state.total
      }
    },
    updateDeviceList: (
      state,
      action: PayloadAction<Omit<DeviceAddResponse["data"][0], "created_date">>
    ) => {
      if (
        state.requests.findIndex((data) => data.id === action.payload.id) >= 0
      ) {
        state.requests = state.requests.filter(
          (data) => data.id !== action.payload.id
        )
        state.total = state.total--
      }
    }
  }
})

export default deviceAddRequestSlice.reducer

export const {addNewRequest, updateDeviceList} = deviceAddRequestSlice.actions

const selectAll = (state: StoreState) => state.deviceAdd

export const useGetAddDeviceRequests = () => useSelector(selectAll)
